import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { cancelTriggerOrder } from '../../../store/actions/triggerOrders/triggerOrdersActions';
import { portfolioFinancialPendingTransactions } from '../../../store/actions/portfolio/portfolioActions';
import { CANCEL_TRIGGER_ORDER_LOADING } from '../../../store/actions/triggerOrders/triggerOrdersActionConstants';
import { selectIsLoadingByActionType } from '../../../store/selectors/loadingSelectors';
import SectionLoader from '../../Loader/SectionLoader';
import ModalButtons from '../../Modal/ModalButtons';
import Paragraph from '../../Paragraph/Paragraph';
import ModalBody from '../../Modal/ModalBody';

const CancelTriggerOrder = ({
  setError,
  handleNext,
  handleClose,
  cancelTransactionData,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { paymentUid, accountUid } = cancelTransactionData;
  const isLoading = useSelector(
    selectIsLoadingByActionType(CANCEL_TRIGGER_ORDER_LOADING),
  );

  const refreshTransactions = () => {
    dispatch(portfolioFinancialPendingTransactions({ accountUid }));
  };

  const handleCancelTriggerOrder = () => {
    dispatch(
      cancelTriggerOrder({
        accountUid,
        triggerOrderUid: paymentUid,
        onSuccess: () => {
          setError('');
          refreshTransactions();
          handleNext();
        },
        onError: (errorMessage) => {
          setError(errorMessage);
          handleNext();
        },
      }),
    );
  };

  return (
    <SectionLoader isLoading={isLoading}>
      <ModalBody>
        <Paragraph>
          {t('portfolio.pendingTransactions.cancelTriggerOrder.text')}
        </Paragraph>
        <ModalButtons
          isHorizontal
          marginTop
          secondaryButtonProps={{
            onClick: handleClose,
            label: t('common.cancel'),
          }}
          primaryButtonProps={{
            onClick: handleCancelTriggerOrder,
            label: t('common.confirm'),
          }}
        />
      </ModalBody>
    </SectionLoader>
  );
};

CancelTriggerOrder.propTypes = {
  setError: PropTypes.func,
  handleNext: PropTypes.func,
  handleClose: PropTypes.func,
  cancelTransactionData: PropTypes.shape({
    paymentUid: PropTypes.string,
    accountUid: PropTypes.string,
  }),
};

export default CancelTriggerOrder;
